import { ActionType, createReducer } from 'typesafe-actions';
import * as actions from 'store/actions/tripsOld';
import { TripsOldResponse } from 'store/types/reports';

const initialState: Array<TripsOldResponse> = [];

export const TripsOldReducer = createReducer<Array<TripsOldResponse>, ActionType<typeof actions>>(
  initialState,
).handleAction(actions.getTripsOld.success, (state, { payload }) => ({
  ...state,
  ...payload,
}));
